import genererOtPatrimoine
  from '@/services/logistique/ordreTravail/tech/genererObject/genererOTPatrimoine';
import genererOTTech from '@/services/logistique/ordreTravail/tech/genererObject/genererOTTech';

export default function addGenerationOtFromDispositifAudit(dispositifs, otsAuditEnfants) {
  const Ots = [];
  dispositifs.forEach((dispositif) => {
    if (otsAuditEnfants?.find((ot) => {
      return ot?.otPatrimoine?.dispositifId === dispositif?.id;
    })) return;

    const ot = genererOTTech();
    ot.otPatrimoine = genererOtPatrimoine();
    ot.otPatrimoine.dispositifId = dispositif.id;
    ot.otPatrimoine.dispositif = dispositif;
    Ots.push(ot);
  });
  return otsAuditEnfants.concat(Ots);
}
